import axios from "axios";
import { getCookie } from "JS/cookie";

export const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async function (config) {
    const accessToken = getCookie("pickAdminMyToken");
    if (accessToken) {
      config.headers["Access-Token"] = accessToken;
    }
    return config;
  },

  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },

  function (error) {
    const status = error?.status;
    if (status === 499) return Promise.reject({ message: "로그인 만료" });

    return Promise.reject(error);
  }
);
